// need to pass services with commission not the layering one.
export const calculateCommission = (services) => {
    if (services?.length > 0) {
        let totalServices = 0;
        let sumServicesPercentage = 0;
        for (let item of services) {
            if (item.percentage) {
                sumServicesPercentage += item.percentage;
                totalServices++
            }
        }
        if (sumServicesPercentage == 0) return 0
        let result = sumServicesPercentage / totalServices;
        return result.toFixed(2);
    }
    else {
        return 0
    }
}